import axios from 'axios';
import _isArray from 'lodash/isArray';
import _find from 'lodash/find';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import { trackPage } from '../../lib/analytics-helper';
import { updateSubTopicDetails, updateTopicDetails } from './action-L3Topic-list';
import i18n from '../../lib/reacti18n';
import { updateTopicTree } from './action-topic-list';
import { updateBreadcrumb } from './action-breadcrumb';
import { getL3TopicInfo } from '../../lib/location-helper';
import { isNewExpLayoutEnabled } from '../../../jsV2/helpers/twHelper';
import l2TopicTreeJSON from '../../../../server/data/topicTree/L2_topicTree.json';

export function requestArticles() {
  return {
    type: types.REQUEST_ARTICLE_LIST,
  };
}

function receiveArticlesResponse(topicList, response, selectedTopic) {
  // Get article page title and Id by using selected topic
  const articleTitle = _get(
    _find(topicList.topics, (topic) => String(topic.topicId) === selectedTopic),
    'topicName',
  );
  const articleId = _get(
    _find(topicList.topics, (topic) => String(topic.topicId) === selectedTopic),
    'topicId',
  );

  // Set article List by using L2 response data
  // No Article Limit for the Topic page
  const articleList = [];
  if (response && response.length > 0) {
    response.forEach((articleSet) => {
      // HACK: Limit the article list to 20
      let faqList = _isArray(articleSet.articles) && articleSet.articles;
      if (faqList && faqList.length > 20) {
        faqList = faqList.slice(0, 20);
      }

      let subTopicList = [];
      if (Array.isArray(articleSet.subTopics) && articleSet.subTopics.length) {
        subTopicList = articleSet.subTopics;
      }

      articleList.push({
        id: articleSet.subTopicId,
        name: articleSet.subTopicName,
        ocpIntent: articleSet.ocpIntent,
        faqList,
        subTopicList,
      });
    });
  }

  return {
    type: types.RECEIVE_ARTICLE_LIST,
    payload: {
      articleList,
      articleTitle,
      articleId,
    },
  };
}

export const receiveL3ArticlesResponse = (topics) => {
  if (topics && Array.isArray(topics.subTopicList)) {
    const L3Topics = topics.subTopicList.map(({ subTopicId, subTopicName, articles }) => ({
      id: subTopicId,
      name: subTopicName,
      faqList: articles,
    }));
    return {
      type: types.RECEIVE_ARTICLE_LIST,
      payload: {
        articleList: L3Topics,
        articleTitle: topics.name,
        articleId: topics.id,
      },
    };
  }
  return null;
};

function receiveArticlesError() {
  return {
    type: types.RECEIVE_ARTICLE_LIST_ERROR,
  };
}

// Function to update breadcrumb on dirct landing on L3 Topic page
const returnBreadCrumbs = (L1Topic, topicSelected, exp) => {
  const topicPath = '/topic';
  const items = [];
  const title = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);
  if (!Page.isMobileLayout()) {
    items.push(
      {
        title,
        path: '/home',
        id: topicSelected,
      },
      {
        title: L1Topic.topicName,
        path: `${topicPath}/${L1Topic.topicId}`,
        id: L1Topic.topicId,
      },
    );
  } else {
    items.push({
      title: L1Topic.topicName,
      path: `${topicPath}/${L1Topic.topicId}`,
      id: L1Topic.topicId,
    });
  }
  return items;
};

export default function getFaqList(topicList, topicSelected, isL2TopicRedirected) {
  return (dispatch, getState) => {
    const exp = Page.getUserExperience();
    if (isNewExpLayoutEnabled()) {
      const pageId = isL2TopicRedirected ? 'L3topicPage' : 'topicPage';
      trackPage({ id: pageId, link: `smarthelp-topic|${topicSelected}` });
      dispatch(updateSubTopicDetails(l2TopicTreeJSON[topicSelected])); // for updating L3Topic reducer
      return dispatch(receiveArticlesResponse(topicList, l2TopicTreeJSON[topicSelected].webTopicTree, topicSelected));
    }
    dispatch(requestArticles());
    const topicTreeUrl = `/smarthelp/web-topic-tree?q=${topicSelected}`;
    return axios
      .get(Page.setChannelForTechnicalExp(topicTreeUrl))
      .then((response) => {
        // FPTI for topic impression event
        const pageId = isL2TopicRedirected ? 'L3topicPage' : 'topicPage';
        trackPage({ id: pageId, link: `smarthelp-topic|${topicSelected}` });

        const state = getState();
        const L1Topic = state.L3TopicList && state.L3TopicList.SelectedL1TopicDetails;
        if (isL2TopicRedirected) {
          const res = response.data && response.data.webTopicTree;
          if (Array.isArray(res) && res.length) {
            const location = state.location;
            const subTopic = getL3TopicInfo(location);
            const selectedL2Topic = [];
            res.forEach((Topic) => {
              if (Topic.subTopicId === subTopic) {
                selectedL2Topic.id = Topic.subTopicId;
                selectedL2Topic.name = Topic.subTopicName;
                selectedL2Topic.subTopicList = Topic.subTopics;
              }
            });

            dispatch(updateTopicDetails(response.data, selectedL2Topic)); // Updating L3Topic redux state
            dispatch(updateTopicTree(response.data, exp)); // Updating topic list state
            dispatch(receiveL3ArticlesResponse(selectedL2Topic));
            dispatch(updateBreadcrumb(returnBreadCrumbs(L1Topic, topicSelected, exp)));
          }
        } else {
          dispatch(updateSubTopicDetails(response.data)); // for updating L3Topic reducer
          dispatch(receiveArticlesResponse(topicList, response.data.webTopicTree, topicSelected));
        }
      })
      .catch(() => {
        // FPTI for error impression event
        const pageId = isL2TopicRedirected ? 'L3topicErrorPage' : 'topicErrorPage';
        trackPage({ id: pageId, link: `smarthelp-error-topics|${topicSelected}` });
        dispatch(receiveArticlesError());
      });
  };
}
